// export const SHIBBOLETH_URL = "https://prod-digitalcorps.servers.bsu.edu/simplesaml/bsu_login.php?redirectURL=https://writing-challenge-api.apsoprojects.org/public/auth/admin";
export const API_URL = "https://writing-challenge-api.apsoprojects.org/public/";
export const BASE_URL = "/";

export const SHIBBOLETH_URL = "https://sso.apsoprojects.org/auth/login"